/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulletinDeliberationNavigationDto
 */
export interface BulletinDeliberationNavigationDto {
    /**
     * 
     * @type {number}
     * @memberof BulletinDeliberationNavigationDto
     */
    idbulletinApprenantType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulletinDeliberationNavigationDto
     */
    idApprenant?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BulletinDeliberationNavigationDto
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the BulletinDeliberationNavigationDto interface.
 */
export function instanceOfBulletinDeliberationNavigationDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulletinDeliberationNavigationDtoFromJSON(json: any): BulletinDeliberationNavigationDto {
    return BulletinDeliberationNavigationDtoFromJSONTyped(json, false);
}

export function BulletinDeliberationNavigationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulletinDeliberationNavigationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idbulletinApprenantType': !exists(json, 'idbulletinApprenantType') ? undefined : json['idbulletinApprenantType'],
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
    };
}

export function BulletinDeliberationNavigationDtoToJSON(value?: BulletinDeliberationNavigationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idbulletinApprenantType': value.idbulletinApprenantType,
        'idApprenant': value.idApprenant,
        'displayName': value.displayName,
    };
}

